import { classNames, h } from "omi";
import isEmpty from "lodash-es/isEmpty";

import { NWIcon } from "@/wc/components/atoms/nw-icon";

import { QuestionStatus, type Quiz } from "../../models";
import { getAttemptDate } from "../../utils.ts";

export function StateIndicator({ quiz }: { quiz: Quiz }) {
  const questions = quiz.questions.length;
  const attempts = quiz.attempts;

  if (attempts != null && !isEmpty(attempts)) {
    const lastAttempt = attempts[attempts.length - 1];
    const lastAttemptDate = getAttemptDate(lastAttempt);
    const hasPassed = lastAttempt?.score === quiz?.questions.length;
    const correctAnswerCount =
      quiz.questions.filter(question => question.status === QuestionStatus.Correct).length || lastAttempt.score;

    return (
      <div
        className={classNames(
          "flex justify-center gap-6 mb-6 bg-black px-4 py-2 rounded-lg w-fit mx-auto border",
          hasPassed ? "border-2 border-[#16C59C]" : "border-2 border-[#FEDF89]",
        )}
      >
        <div className="flex items-center text-white text-sm space-x-1">
          <div className="h-5 bg-leather border border-[#373A41] px-1.5 py-0.5 text-xs rounded-md">
            <span className="text-white">
              {correctAnswerCount}/{questions}
            </span>
          </div>
          <span>{correctAnswerCount === questions ? "😎 Perfect score" : "Answers correct"}</span>
        </div>

        <div className="flex items-center text-white text-sm space-x-1">
          <div className="h-5 bg-leather border border-[#373A41] px-1.5 py-0.5 text-xs rounded-md">
            <span className="text-white">{lastAttemptDate}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 bg-black px-4 py-2 rounded-lg w-fit mx-auto border border-brand">
      <div className="flex items-center text-white text-sm space-x-1">
        <NWIcon name="help" width={13} height={13} className="text-brand-700"></NWIcon>
        <span>{questions} questions</span>
      </div>
      <div className="flex items-center text-white text-sm space-x-1">
        <NWIcon name="hourglass" width={14} height={14} className="text-brand-700"></NWIcon>
        <span>{questions * 0.5} minutes</span>
      </div>
    </div>
  );
}

// function getQuizState(quiz: Quiz) {
//   const totalQuestions = quiz.questions.length;
//   const totalAttempts = quiz.attempts.length;
//   const totalPassed = quiz.attempts.filter(attempt => attempt.score === 100).length;
//
//   if (totalAttempts === 0) {
//     return QuizStatus.NotStarted;
//   }
//
//   if (totalPassed < totalQuestions) {
//     return QuizStatus.BelowPassingScore;
//   }
//
//   return QuizStatus.Passed;
// }
